import { usePositionValue } from './usePositionValue'
import { useTotalSpotConversionMarginValue } from './useTotalSpotConversionMarginValue'
import { useMemo } from 'react'
import { bn, e2w, isZero } from '../../utils/number'
import { BigNumber } from 'ethers'
import { useTotalFrozenMargin } from './useTotalFrozenMargin'
import { useRealTimeUnrealizedPnL } from './useRealTimeUnrealizedPnL'

export function useAccountLeverage(): BigNumber {
  const positionValue = usePositionValue()
  const spotMargin = useTotalSpotConversionMarginValue()
  const frozenMargin = useTotalFrozenMargin()
  const unrealizedPnL = useRealTimeUnrealizedPnL()

  return useMemo(() => {
    if (isZero(positionValue) || isZero(spotMargin)) return bn('0')

    return e2w(positionValue).div(
      spotMargin.sub(frozenMargin).add(unrealizedPnL),
    )
  }, [positionValue, spotMargin, frozenMargin, unrealizedPnL])
}
